import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAviKBMBdPYlFt2sMAKQapo8UMyfy4a3qk",
  authDomain: "merced-booking.firebaseapp.com",
  projectId: "merced-booking",
  storageBucket: "merced-booking.firebasestorage.app",
  messagingSenderId: "1050070351726",
  appId: "1:1050070351726:web:f12d5f826381a007b20b7f",
  measurementId: "G-2ZX6FG1CSS"
};


const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app);

if (window.location.hostname === 'localhost') {
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

export { app, db, auth, functions };
